import { CandelabraIcon } from './CandelabraIcon';

/**
 * author: Colton Wiscombe
 * id 1D56356A-1601-41FC-9D98-67736772260B
 * name candelabra
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/candelabra.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const CandelabrumIcon = CandelabraIcon;
export default CandelabrumIcon